import React from "react";
import { Link } from "react-router-dom";
import "../styles/not-found.css";

function NotFound() {
  return (
    <main className="not-found">
      <h1>404</h1>
      <p>Page not found.</p>
      <Link to="/" className="btn-primary">Go Home</Link>
    </main>
  );
}

export default NotFound;
